
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/background.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-graph-background-demo-api-graph-background"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/background.zh.md?type=demo')
};